import dayjs from 'dayjs';
import { LocalStorageService } from 'shared/lib/localStorage';
import { LOGOUT_TIME_KEY } from '../const';

export const updateLogoutTime = (logoutTime: dayjs.Dayjs): void => {
  LocalStorageService.setItem(LOGOUT_TIME_KEY, logoutTime.toISOString());
};
